// extracted by mini-css-extract-plugin
export default {"header":"MyDaters_header__a8X-z","daterHeader":"MyDaters_daterHeader__H26k8","subheader":"MyDaters_subheader__rque6"};